import React from "react";
// import CommonBanner
import CommonBanner from "../component/Common/CommonBanner";
// import BecomeExpertArea
import InstantInquiryForm from "../component/InstantInquiryForm";

const InstantInquiry = () => {
  return (
    <>
      <CommonBanner
        heading="HOUSE OF POLANI – YOUR ONE-STOP TRAVEL SOLUTION






"
        pagination="Instant Inquiry"
      />
      <InstantInquiryForm />
    </>
  );
};

export default InstantInquiry;
